import * as React from 'react';
import { observer } from 'mobx-react';
import { Alert } from '@payscale/design';
import { cycleRules } from 'utils/MobxDataManager/singletons';
import './previewCycleAlert.scss';

export class PreviewCycleAlert extends React.Component {
    render(): React.ReactNode {
        if (!cycleRules.isCurrentCycleInPreviewMode) {
            return null;
        }

        return (
            <Alert
                message={this.renderPreviewMessage()}
                level="info"
                close={true}
                className="nomst-preview-cycle-alert"
            />
        );
    }

    renderPreviewMessage(): React.ReactNode {
        return (
            <div className="nomst-preview-cycle-alert__message-container">
                <div className="nomst-preview-cycle-alert__header">
                    You are currently previewing the upcoming cycle
                </div>
                <div className="nomst-preview-cycle-alert__body">
                    All pay decisions are for testing purposes and will not be submitted for final review.
                </div>
            </div>
        );
    }
}

export default observer(PreviewCycleAlert);